import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box
} from "@mui/material";
import { Link } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";

const VehicleCard = ({
  image,
  name,
  description,
  version = "red", // Keep for compatibility
  sx = {} // Allow custom styling from parent
}) => {
  // Split the description into parts
  const descriptionParts = description ? description.split(", ") : [];
  
  // Extract the first part of the name for the badge
  const vehicleType = name.split(" ")[0];
  
  // Get icon based on name
  const getVehicleIcon = () => {
    const nameLower = name.toLowerCase();
    if (nameLower.includes("bus")) return <DirectionsBusIcon />;
    return <LocalTaxiIcon />;
  };

  return (
    <Card
      sx={{
        width: "360px", // Fixed width based on your images
        border: "1px solid #db352a",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
        ...sx
      }}
    >
      {/* Image section with badge */}
      <Box sx={{ position: "relative" }}>
        <CardMedia
          component="img"
          image={image}
          alt={name}
          sx={{
            width: "100%",
            height: "220px", // Taller image area
            objectFit: "cover"
          }}
        />
        
        {/* Vehicle badge */}
        <Box
          sx={{
            position: "absolute",
            top: "16px",
            right: "16px",
            backgroundColor: "#db352a",
            color: "white",
            padding: "4px 10px",
            borderRadius: "4px",
            display: "flex",
            alignItems: "center",
            gap: 1
          }}
        >
          {getVehicleIcon()}
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            {vehicleType}
          </Typography>
        </Box>
      </Box>

      {/* Title bar */}
      <Box
        sx={{
          backgroundColor: "#db352a",
          padding: "12px",
          color: "white",
          textAlign: "center"
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          {name}
        </Typography>
      </Box>

      {/* Features list */}
      <CardContent sx={{ padding: "16px", flexGrow: 1 }}>
        {descriptionParts.map((part, index) => (
          <Box 
            key={index}
            sx={{ 
              display: "flex", 
              alignItems: "flex-start",
              mb: 1.5
            }}
          >
            <CheckCircleOutlineIcon 
              sx={{ 
                color: "#db352a",
                mr: 1,
                fontSize: "1.1rem",
                mt: 0.2,
                flexShrink: 0
              }} 
            />
            <Typography variant="body2">
              {part}
            </Typography>
          </Box>
        ))}
      </CardContent>

      {/* Book button */}
      <Box sx={{ p: "16px", pt: 0 }}>
        <Button
          component={Link}
          to="/booking"
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#db352a",
            color: "white",
            padding: "10px",
            fontWeight: "bold",
            textTransform: "uppercase",
            borderRadius: "4px",
            "&:hover": {
              backgroundColor: "#c62f27"
            }
          }}
        >
          BOOK NOW
        </Button>
      </Box>
    </Card>
  );
};

export default VehicleCard;